export default __webpack_public_path__ + "static/media/cosmelan-peel.7c0c4e12.jpeg";